import React from 'react';
import { Navigate, RouteObject, useRoutes } from 'react-router-dom';

const UserManagement = React.lazy(() => import('./UserManagement'));

const UserManagementLayout: RouteObject[] = [
  {
    path: '/',
    element: <UserManagement />,
  },
  { path: '*', element: <Navigate to="/404" /> },
];

const UsersManagementRoutes = () => useRoutes(UserManagementLayout);
export default UsersManagementRoutes;
